import { Badge, type StyleProps, Tooltip } from '@chakra-ui/react';
import {
  RESOURCE_STATUSES,
  type RESOURCE_STATUSES_TYPE,
} from '@duke-hq/shared-constants/resourceStatuses';

const statuses: {
  name: RESOURCE_STATUSES_TYPE;
  bg: string;
  variant?: string;
  value?: string;
  label?: string;
}[] = [
  { name: RESOURCE_STATUSES.NOT_STARTED, bg: 'blue', variant: 'outline' },
  { name: RESOURCE_STATUSES.COMPLETED, bg: 'green' },
  { name: RESOURCE_STATUSES.SUBMITTED, bg: 'gray' },
  { name: RESOURCE_STATUSES.PENDING, bg: 'blue', variant: 'outline' },
  { name: RESOURCE_STATUSES.REVISION, bg: 'red' },
  { name: RESOURCE_STATUSES.NOT_YET_SATISFACTORY, bg: 'red' },
  { name: RESOURCE_STATUSES.SATISFACTORY, bg: 'green' },
  { name: RESOURCE_STATUSES.IN_PROGRESS, bg: 'blue' },
  { name: RESOURCE_STATUSES.NOT_REQUIRED, bg: 'gray' },
  { name: RESOURCE_STATUSES.LOCKED, bg: 'gray', variant: 'outline' },
  { name: RESOURCE_STATUSES.NOT_YET_AVAILABLE, bg: 'gray', variant: 'outline' },
  { name: RESOURCE_STATUSES.ON_TRACK, bg: 'green', variant: 'solid' },
  { name: RESOURCE_STATUSES.OVERDUE, bg: 'orange', variant: 'solid' },
  { name: RESOURCE_STATUSES.AT_RISK, bg: 'red', variant: 'solid' },
  { name: RESOURCE_STATUSES.CREDIT_TRANSFER, bg: 'gray', value: 'CT', label: 'Credit Transfer' },
  {
    name: RESOURCE_STATUSES.RECOGNITION_OF_PRIOR_LEARNING,
    bg: 'gray',
    value: 'RPL',
    label: 'Recognition of Prior Learning',
  },
  { name: RESOURCE_STATUSES.PAUSED, bg: 'cyan', variant: 'outline' },
  { name: RESOURCE_STATUSES.DELETED, bg: 'red', variant: 'solid' },
  { name: RESOURCE_STATUSES.SUPERSEDED, bg: 'red', variant: 'solid' },
  { name: RESOURCE_STATUSES.PENDING_SUPERSESSION, bg: 'red', variant: 'solid' },
  { name: RESOURCE_STATUSES.PENDING_REVIEW, bg: 'orange', variant: 'outline' },
];

type ResourceStatusBadgeProps = {
  status: keyof typeof RESOURCE_STATUSES;
  toolTipLabel?: React.ReactNode;
};

export function ResourceStatusBadge({
  status,
  toolTipLabel,
}: ResourceStatusBadgeProps): React.ReactElement {
  let bg: StyleProps['bg'] = 'gray';
  let variant = 'solid';
  let value: string | undefined;
  let label: React.ReactNode;

  const matchedStatus = statuses.find((s) => s.name === status);
  if (matchedStatus) {
    variant = matchedStatus?.variant ?? variant;
    bg = matchedStatus.bg;
    value = matchedStatus.value;
    label = toolTipLabel !== undefined ? toolTipLabel : (matchedStatus.label ?? status);
  }

  let formattedStatus = status.replace(/_/g, ' ');
  formattedStatus =
    formattedStatus.charAt(0).toUpperCase() + formattedStatus.slice(1).toLowerCase();

  return (
    <Tooltip hasArrow label={label} textAlign="center">
      <Badge
        fontSize="xs"
        fontWeight="bold"
        borderRadius="full"
        colorScheme={bg}
        variant={variant}
        whiteSpace="nowrap"
        textTransform="none"
      >
        {value ?? formattedStatus}
      </Badge>
    </Tooltip>
  );
}
